import jwtDecode from 'jwt-decode'

// this should be an api call but for now we just hard code
const PAGE_PERMISSIONS = {
  '/login': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
  '/admin': [1, 2, 3, 5, 7, 9, 12],
  '/configuration': [1, 2],
  '/users': [1],
  '/contacts': [1],
  '/storage': [1, 2, 3, 5, 7, 9, 12],
  '/locations': [1, 2, 3, 5, 7, 9, 12, 15],
  '/insurance': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  '/dashboard': [1, 2, 3, 5, 7, 9, 12],
  '/adas': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
}

export default {
  token: (state) => state.token,
  passthrough: (state) => state.passthrough,
  user: (state) => (state.token ? jwtDecode(state.token) : {}),
  isAllowed: (state) => {
    return (page = '') => {
      if (!PAGE_PERMISSIONS[page]) {
        return true
      }
      if (state.profile.roles && state.profile.roles.length) {
        return state.profile.roles.some((r) => PAGE_PERMISSIONS[page].includes(r))
      }
      return PAGE_PERMISSIONS[page].includes('Guest')
    }
  },
  profile: (state) => state.profile,
  rootFirmPreferences: (state) => state.rootFirmPreferences
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js